import React from 'react'
import './questionCard.css'

function INCSUBQuestionCard({ isExpanded, handleToggle, obj=null, }) {

    return (
        <div className='INCSUBQuestions_ctn_QA_card'>
            <div className='INCSUBQuestions_ctn_QA_card_div'>
                <div className='INCSUBQuestions_ctn_QA_card_div_text'>
                    <div>✦</div>
                    {obj?.question}
                </div>
                {
                    isExpanded ? (

                        <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ cursor: 'pointer' }} onClick={(e) => {
                            e.stopPropagation(); // Prevents click from bubbling to the parent
                            handleToggle()

                        }}>
                            <g clip-path="url(#clip0_1942_12637)">
                                <path d="M8.56149 7.67679C9.08952 7.14876 9.94563 7.14876 10.4737 7.67679L23.8589 21.062C24.3869 21.5901 24.3869 22.4462 23.8589 22.9742C23.3309 23.5022 22.4748 23.5022 21.9467 22.9742L8.56149 9.58897C8.03346 9.06093 8.03346 8.20482 8.56149 7.67679Z" fill="#EFEFEB" fill-opacity="0.8" />
                                <path d="M21.9482 7.67679C22.4762 7.14876 23.3324 7.14876 23.8604 7.67679C24.3884 8.20482 24.3884 9.06093 23.8604 9.58897L10.4752 22.9742C9.94712 23.5022 9.09101 23.5022 8.56298 22.9742C8.03494 22.4462 8.03494 21.5901 8.56297 21.062L21.9482 7.67679Z" fill="#EFEFEB" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1942_12637">
                                    <rect width="21.6338" height="21.6338" fill="white" transform="translate(16.2109 0.0292969) rotate(45)" />
                                </clipPath>
                            </defs>
                        </svg>
                    ) : (
                        <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{cursor: 'pointer'}} onClick={(e) => {
                            e.stopPropagation(); // Prevents click from bubbling to the parent
                            handleToggle()
                        }}>
                            <g clip-path="url(#clip0_1942_12648)">
                                <path d="M0.394531 11.1431C0.394531 10.3964 0.999893 9.79102 1.74664 9.79102H20.6762C21.423 9.79102 22.0283 10.3964 22.0283 11.1431C22.0283 11.8899 21.423 12.4952 20.6762 12.4952H1.74664C0.999893 12.4952 0.394531 11.8899 0.394531 11.1431Z" fill="#EFEFEB" fill-opacity="0.8" />
                                <path d="M9.85938 1.67828C9.85938 0.931534 10.4647 0.326172 11.2115 0.326172C11.9582 0.326172 12.5636 0.931533 12.5636 1.67828V20.6079C12.5636 21.3546 11.9582 21.96 11.2115 21.96C10.4647 21.96 9.85938 21.3546 9.85938 20.6079V1.67828Z" fill="#EFEFEB" fill-opacity="0.8" />
                            </g>
                            <defs>
                                <clipPath id="clip0_1942_12648">
                                    <rect width="21.6338" height="21.6338" fill="white" transform="translate(0.394531 0.326172)" />
                                </clipPath>
                            </defs>
                        </svg>

                    )
                }

            </div>
            {isExpanded &&
                <div className='INCSUBQuestions_ctn_QA_card_div_text_para'>
                    {obj?.solution}
                </div>
            }
        </div>
    )
}

export default INCSUBQuestionCard;
